import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M32.652 27a1 1 0 0 1 1-1c2.756 0 5.511.223 8.266.67a4 4 0 0 1 3.207 2.853l.622 2.184c.022.078.042.157.06.237.464 2.11-.912 4.187-3.001 4.754a42.496 42.496 0 0 1-6.09 1.158 1 1 0 0 1-1.104-.884c-.03-.27-.355-2.72-1.073-5.028-.747-2.4-1.887-4.662-1.887-4.944Zm-5-9c0-3.312 2.69-6 6-6 3.312 0 6 2.69 6 6 0 3.312-2.69 6-6 6-3.312 0-6-2.69-6-6Zm-10 24c-5.955 0-10.33-.564-13.165-1.722a4 4 0 0 1-2.41-4.485l.778-3.898a7 7 0 0 1 6.272-5.605c2.275-.194 5.116-.29 8.525-.29 3.41 0 6.25.096 8.525.29a7 7 0 0 1 6.272 5.605l.777 3.898a4 4 0 0 1-2.41 4.485C27.984 41.436 23.607 42 17.653 42Zm-8-28c0-4.416 3.587-8 8-8 4.416 0 8 3.587 8 8 0 4.416-3.587 8-8 8-4.416 0-8-3.587-8-8Z",
      clipRule: "evenodd"
    }
  )
);
var SvgPeopleFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var PeopleFilled_default = SvgPeopleFilled;

export { PeopleFilled_default as default };
